import { z } from 'zod';
import { uuidSchema } from '../../common/schemas/id.schemas.js';
export const userRoleSchema = z.enum(['MANAGER', 'ENGINEER']);
/** The trimmed user shape that travels with every token payload and `auth.me` response. */
export const userSummarySchema = z.object({
    id: uuidSchema,
    email: z.string().email(),
    name: z.string().min(1),
    role: userRoleSchema,
});
export const loginInputSchema = z.object({
    email: z.string().min(1, 'Email is required').email('Enter a valid email address'),
    password: z.string().min(1, 'Password is required'),
});
export const refreshInputSchema = z.object({
    refreshToken: z.string().min(1, 'Refresh token is required'),
});
export const tokensOutputSchema = z.object({
    accessToken: z.string().min(1),
    refreshToken: z.string().min(1),
    user: userSummarySchema,
});
//# sourceMappingURL=auth.schemas.js.map